import axios from 'axios';

/**
 * Resolve API base URL from env template + current browser hostname.
 *
 * Templates:
 *   http://__HOSTNAME__:8000/api/   → abc.otobonik.localhost:8080
 *                                     becomes http://abc.otobonik.localhost:8000/api/
 *   http://api-__HOST__/api/        → docker-proxy style (full host incl. port)
 *
 * If VUE_APP_API_BASE_URL is empty, defaults to same hostname on VUE_APP_API_PORT (8000).
 */
function resolveApiBaseUrl() {
  const template = (process.env.VUE_APP_API_BASE_URL || '').trim();
  const apiPort = process.env.VUE_APP_API_PORT || '8000';
  const { protocol, hostname } = window.location;

  let url = template;
  if (!url) {
    url = `${protocol}//__HOSTNAME__:${apiPort}/api/`;
  }

  if (url.includes('__HOSTNAME__')) {
    url = url.split('__HOSTNAME__').join(hostname);
  }
  if (url.includes('__HOST__')) {
    url = url.split('__HOST__').join(window.location.host);
  }

  if (!url.endsWith('/')) {
    url += '/';
  }
  return url;
}

const baseURL = resolveApiBaseUrl();
window.API_BASE_URL = baseURL;
window.API_HOST_URL = baseURL.replace(/\/api\/?$/, '');

// Create a new axios instance
const axiosInstance = axios.create({
  baseURL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add request interceptor to attach the token to the request
axiosInstance.interceptors.request.use(
  (config) => {
    const authToken = localStorage.getItem('auth_token');
    const storeId = localStorage.getItem('store_id');

    if (authToken) {
      // Set the Authorization header with the Token prefix
      config.headers['Authorization'] = `Token ${authToken}`;
    }

    if (storeId) {
      config.headers["X-Store-ID"] = storeId;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Add response interceptor to handle errors globally (optional)
axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      // Handle unauthorized (e.g., logout user)
      localStorage.removeItem('auth_token');
      // The saved store belongs to this login; a stale one makes the next user's calls 403.
      localStorage.removeItem('store_id');
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;
